export const KCAL_TO_KJ = 4.184

export function calculateEnergy({ sex, age, height, weight, activity }) {
  const values = [age, height, weight, activity].map(Number)
  if (values.some((value) => !Number.isFinite(value))) return null
  if (age < 18 || age > 100 || height < 120 || height > 230 || weight < 30 || weight > 250) return null

  const offset = sex === "female" ? -161 : 5
  const bmr = 10 * weight + 6.25 * height - 5 * age + offset
  const total = bmr * activity
  return { bmr: Math.round(bmr), total: Math.round(total), kilojoules: Math.round(total * KCAL_TO_KJ) }
}
